const OrganisationHierarchyTypes = {
    JOB_FUNCTION: "jobFunction",
    ORGANISATION: "organisation",
    PROJECT: "project",
    SUB_ORGANISATION: "subOrganisation",
};

export default OrganisationHierarchyTypes;
